/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiRequestDetail = zod
	.object({
		api_key_id: zod.string().nullable().describe('API key ID'),
		api_key_prefix: zod.string().nullable().describe('Public id of the API key'),
		auth_type: zod.string().nullable().describe('Authentication type'),
		duration_ms: zod.number().describe('Request duration in ms'),
		event_id: zod.string().describe('Event ID'),
		ip_address: zod.string().nullable().describe('Client IP'),
		method: zod.string().describe('HTTP method'),
		occurred_at: zod.iso.datetime({ offset: true }).describe('When the request occurred'),
		praetor_id: zod.string().nullable().describe('Praetor ID'),
		request_body_url: zod.string().nullable().describe('Signed URL to request body (5 min TTL)'),
		request_id: zod.string().nullable().describe('Phoenix request id'),
		response_body_url: zod.string().nullable().describe('Signed URL to response body (5 min TTL)'),
		route_pattern: zod.string().describe('Route pattern'),
		status_class: zod.number().describe('HTTP status class'),
		status_code: zod.number().describe('HTTP status code'),
		user_agent: zod.string().nullable().describe('User agent')
	})
	.describe('API request detail');

export type ApiRequestDetail = zod.input<typeof ApiRequestDetail>;
export type ApiRequestDetailOutput = zod.output<typeof ApiRequestDetail>;
